import React, { useEffect, useState } from 'react';
import { Promoter } from '../SiteClasses';
import { useBreadcrumbs } from '../hooks';
import { Header, Table, Pagination, Groupper, Input } from 'react-frontier';
import moment from 'moment';
import API from '../API';
import { Link } from 'react-router-dom';

interface PromotersListProps{
	
}

const PAGE_SIZE = 20;

var PromotersList = (props: PromotersListProps)=>{
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [promoters, setPromoters] = useState<Promoter[]>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [filter, setFilter] = useState<string>('');
	var [searchPromoters, setSearchPromoters] = useState<Promoter[]>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Promotores');
		get();
	}, []);

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getPromoters(PAGE_SIZE, offset).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setPromoters(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los promotores. (GPL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
		setLoading(true)
		setPage(page);
		get(page);
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		setPage(0);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			setSearchPromoters(null);
			return;
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	};

	var search = (query: string)=>{
		setSearching(true);
		setSearchPromoters(null);
		setPage(0);
		
		API.searchPromoters(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchPromoters(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar promotores. (SPS-1)');
		}).finally(()=>{
			setSearching(false);
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!promoters) return <Header text='Cargando datos' loading />

	var shown_promoters = searchPromoters || promoters;

	return <div>
		<Groupper
			title={'Promotores'}
			width={700}
			style={{ marginTop: 20 }}
		>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} style={{ margin: 0}} />
			<Table
				striped
				className='first last'
				style={{ marginTop: 15 }}
				headers={['ID', 'Nombre', 'Fecha', 'Eventos']}
				collapsingIndexes={[0, 3]}
				footer={(!!shown_promoters && shown_promoters.length >= PAGE_SIZE || page !== 0) && (
					<Table.Cell colSpan={4} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_promoters.length>=PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={4}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_promoters.length !== 0 ? (
						shown_promoters.map(promoter => {
							return (
								<Table.Row 
									selectable 
									compact 
									striped
									as={Link}
									to={`/promoters/${promoter.promoter_id}`}
									centeredIndexes={[3]}
									key={promoter.promoter_id}
									data={[
										promoter.promoter_id,
										promoter.promoter_name,
										moment.unix(promoter.date_created).format('DD/MM/YY HH:mm'),
										promoter.events_count,
									]}
								/>
							);
						})
					) : (
						<Table.Cell row className='empty' colSpan={4}>
							No se encontraron promotores
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
	</div>
}

export default PromotersList;	